module.exports = __webpack_public_path__ + "455c8684cfb45828fb9dbce73ba128c8.svg";